import { IFontSizes } from "../theme.types";
import { fontSizes } from "../typography/font-sizes";

export const getFontThemeSize = (key: keyof IFontSizes): string =>
  `${fontSizes[key]}px`;

export const increaseFontSize = (size: number): string => {
  const { base } = fontSizes;
  return `${base + size}px`;
};

export const decreaseFontSize = (size: number): string => {
  const { base } = fontSizes;
  return `${base - size}px`;
};
